<template>
  <div class="homepage">

    <div class="homesection top">
      <div class="dimmer"></div>
      <div class="intro" v-parallax=".3">
<!--           <h1>{{plCount}} locations ready for <div class="dropincontainer"><b class="first">movies</b> <b class="second">television</b> <b class="third">photo shoots</b> <b class="final">your production</b></div></h1> -->
          <h1>{{plCount}} locations ready for filming</h1>
          <div class="search">
            <div class="search-inner">
              <img src="../assets/icon.svg">
<!--               <input type="text" @focus='showTyper = false, searchPlaceholder = "Search... "' :placeholder="searchPlaceholder"> -->
              <Autocomplete :searchPlaceholder="searchPlaceholder" :styling="'home'" @searchFocus='showTyper = false, searchPlaceholder = "Search... "' @select='searchSelect' />
              <i class="material-icons">search</i>
              <vue-typer v-if='showTyper' :text='["Loft", "Bar", "Rooftop", "Garage", "Pool", "Victorian", "Mid-century", "Downtown", "Beachfront", "Industrial"]' erase-style='clear' initial-action='typing' :shuffle="true"></vue-typer>
            </div>
            <router-link class="advanced-search" :to="'/browse'">Advanced Search</router-link>
          </div>
      </div>
     <div class="parallax-cutter">
        <div class="parallax-container" v-parallax =".5">
             <img :src="'https://img.productionlocations.com/'+sitecontent.homepage.top">
        </div>
     </div>
   </div>
   <div class="browse-section">
      <h2><router-link :to="'/browse'">Browse Locations</router-link></h2>
      <div class="featured-tags">
        <div v-for="featuredTag in sitecontent.featuredtags" class="featured-tag">
          <router-link :to="'/browse/'+featuredTag.slug">
            <div class="img"><img :src="'https://img.productionlocations.com/'+featuredTag.url"></div>
            <div class="overlay">
              <p class="name" v-text="featuredTag.name"></p>
              <p class="plcount" v-text="featuredTag.plcount+' Locations'"></p>
            </div>
          </router-link>
        </div>
        <div class="featured-tag see-all">
          <router-link :to="'/browse/'">
            <span>
              <i class="material-icons">arrow_forward</i>
              All Categories
            </span>
          </router-link>
        </div>
      </div>
   </div><!-- /.browse-section -->

<!--
   <div class="featured-locations">
    <h1>Featured Locations</h1>
    <div class="featured-carousel">
      <carousel :perPage='1' :paginationEnabled='true' :loop='true' ref='carousel' :autoplay="true" :autoplayTimeout="5500">
        <slide>
          <div class="slide">
            <router-link :to="'/location/3924'"><img src="https://img.productionlocations.com/wp-content/uploads/2017/04/1101-Lo-6-880x502.jpg" /></router-link>
            <div class="overlay">
              <h3>PL4410</h3>
              Residential, Mid-city, Event Space
            </div>
          </div>
        </slide>
        <slide>
          <div class="slide">
            <router-link :to="'/location/3924'"><img src="https://img.productionlocations.com/wp-content/uploads/2017/04/PL4398-29-880x502.jpg" /></router-link>
            <div class="overlay">
              <h3>PL4398</h3>
              Religious, East LA, Spanish
            </div>
          </div>
        </slide>
        <slide>
          <div class="slide">
            <router-link :to="'/location/3924'"><img src="https://img.productionlocations.com/wp-content/uploads/2017/03/PL4296-76-880x502.jpg" /></router-link>
            <div class="overlay">
              <h3>PL4296</h3>
              Mansion, Glendale, Mediterranean
            </div>
          </div>
        </slide>
        <slide>
          <div class="slide">
            <router-link :to="'/location/3924'"><img src="https://img.productionlocations.com/wp-content/uploads/2017/06/PL4506-60-880x502.jpg" /></router-link>
            <div class="overlay">
              <h3>PL4506</h3>
              House, Moroccan, Hollywood
            </div>
          </div>
        </slide>
      </carousel>
      <div class="next-button carousel-button">
        <i class="material-icons" @click='advanceCarousel'>keyboard_arrow_right</i>
      </div>
      <div class="previous-button carousel-button">
        <i class="material-icons" @click='advanceCarousel("backward")'>keyboard_arrow_left</i>
      </div>
      <span class="clear"></span>
    </div>
   </div>
-->

    <div class="homesection second">
<!--       <div v-parallax=".1"  class="headline">Commercial, residential, industrial, and <b>everything</b> in between</div> -->
      <div class="headline">Commercial, residential, industrial, and <b>everything</b> in between</div>
      <div class="parallax-container" v-parallax =".5">
             <img :src="'https://img.productionlocations.com/'+sitecontent.homepage.middle">
      </div>
   </div>
<!--
    <div class="homesection third">
      <div v-parallax="-.1"  class="headline">This is <b>overlay</b> text</div>
      <div class="parallax-container" v-parallax =".2">
         <img src="https://img.productionlocations.com/wp-content/uploads/2017/03/PL4306-6.jpg">
      </div>
   </div>
-->
    <div class="homesection fourth">
<!--       <div v-parallax="-.3"  class="headline">Start your search today</div> -->
      <div class="headline">Start your search today<br> <router-link :to="'/browse'">Browse Locations</router-link></div>
      <div class="parallax-container" v-parallax =".5">
             <img :src="'https://img.productionlocations.com/'+sitecontent.homepage.bottom">
      </div>
   </div>
    <div class="bottom-yellow">
    </div>

  </div>
</template>

<script>
import Autocomplete from './Autocomplete'
export default {
  name: 'Home',
  data () {
    return {
      plCount: Object.keys(this.$root.PLs).length.toLocaleString(),
      showTyper: false,
      searchPlaceholder: 'Search...',
      sitecontent: this.$root.sitecontent
    }
  },
  methods: {
    activateTyper () {
      if (this.searchPlaceholder !== 'Search... ') {
        this.showTyper = true
        this.searchPlaceholder = ''
      }
    },
    searchSelect (option) {
      if (option.plcount !== undefined) {
        this.$router.push('/browse/' + option.slug)
        return false
      }
      if (option.plno !== undefined) {
        this.$router.push('/location/' + option.plno)
        return false
      }
    },
    advanceCarousel: function (direction) {
      this.$refs.carousel.advancePage(direction)
    }
  },
  computed: {
  },
  created () {
    setTimeout(this.activateTyper, 4000)
    document.title = 'Production Locations for Film, TV, Commercial, Photo Productions.'
    document.head.querySelector('meta[name=description]').content = 'Film and production locations in Los Angeles for exclusive use in motion picture, television, commercial and photography productions. Great scouting tool.'
  },
  components: {
    Autocomplete
  },
  mounted: function () {
    this.$root.logActivity('Viewing Home Page')
  }
}
</script>

<style lang="scss">
@import "../styles/_mixins.scss";
.intro {
  position: absolute;
  left:5%;
  text-align: center;
  top: 18vh;
  width: 90%;
  z-index: 15;
  @include bp(most) {
    left:0px;
    width: 100%;
    top: 25vh;
  }
  img {
    width: 60px;
    height: 60px;
    vertical-align: middle;
    margin-bottom: 22px;
    @include bp(most) {
      margin-top: -5px;
      margin-right: 1em;
      margin-left: -26px;
      margin-bottom: 0px;
    }
  }
  h1 {
    color: #FFF;
    font-weight: 800;
    font-size: 18px;
    margin: 0 0 1.5em;
    animation-name: dropFadeIn;
    animation-duration: 2s;
    position: relative;
    @include bp(most) {
      font-size: 48px;
      margin: 0 0 1.5em;
    }
  }
  .search {
    position: relative;
    .search-inner {
      position: relative;
      z-index: 2;
      @include bp(most) {
        display: inline-block;
      }
    }
    .autocomplete-input {
      @include bp(most) {
        display: inline-block;
      }
    }
    input {
      font-family: $noto;
      font-size: 14px;
      padding: 10px 20px;
      width: 100%;
      border: 1px solid #E7E7E7;
      outline: none;
      border-radius: 2px;
      vertical-align: middle;
      &::placeholder {
        color: #B8B8B8;
      }
      @include bp(mobile) {
        box-sizing: border-box;
      }
      @include bp(most) {
        font-size: 18px;
        padding: 10px 20px;
        width: 375px;
      }
    }
    i {
      color: #DDD;
      font-size: 25px;
      line-height: 0;
      position: absolute;
      right: 6px;
      top: 104px;
      @include bp(most) {
        position: relative;
        top: 10px;
        left: -38px;
      }
    }
    .advanced-search {
      color: #FFF;
      text-decoration: none;
      position: absolute;
      left: 50%;
      top: 10em;
      width: 160px;
      text-align: center;
      margin-left: -80px;
      text-decoration: underline;
      @include bp(most) {
        top: 5em;
        margin-left: -72px;
      }
    }
  }
}

</style>
<style scoped lang="scss">
@import "../styles/_mixins.scss";
.homesection {
    overflow: hidden;
    position: relative;
    height: 60vh;
    background: $notblack;
    @include bp(most) {
      height: 80vh;
    }
    .headline {
      position: absolute;
      margin-top: -8vh;
      z-index: 20;
      font-weight: 800;
      color: #FFF;
      text-shadow: 0px 0px 40px rgba(0,0,0,.7);
      font-size: 24px;
      width: 90%;
      left: 5%;;
      top: 50%;
      @include bp(most) {
        left: 200px;
        top: 50%;
        width: 35%;
        font-size: 48px;
      }
      b {
        color: $yellow;
      }
      a {
        display: inline-block;
        font-weight: 500;
        color: #FFF;
        background: $yellow;
        padding: .325em .5em;
        line-height: 1.4;
        border-radius: 3px;
        text-shadow: none;
        text-decoration: none;
        font-size: 18px;
        margin-top: .5em;
        @include bp(most) {
          font-size: 24px;
          margin-top: 0;
        }
      }
    }
    &.top {
      overflow: visible;
      height: 70vh;
      .parallax-cutter {
        width: 100%;
        height: 70vh;
        overflow: hidden;
      }
      @include bp(most) {
        height: 80vh;
        .parallax-cutter {
          height: 80vh;
        }
      }
    }
    &.third .headline {
      top: 75%;
    }
    &.fourth .headline {
      text-align: right;
      @include bp(most) {
        left: 55%;
      }
    }

}
.dimmer {
    background: rgba(0,0,0,.5);
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 70vh;
    @include bp(most) {
      height: 80vh;
    }
}

.parallax-container {
  position: relative;
  padding-top: 66.8081%;
  backface-visibility: hidden;
  img {
    position: absolute;
    left: 0px;
    min-height: 116.5vh;
    min-width: 100%;
    width: auto;
    top: -50vh;
    margin-left: 50%;
    transform: translateX(-50%);
    @include bp(most) {
      top: -27vh;
    }
    .homesection.top & {
      @include bp(mobile) {
        min-height: 60vh;
        height:80vh;
      }
      @include bp(most) {
        min-height: 90vh;
      }
    }
  }
}
.homesection.top img {
    top: -16vh;
    @include bp(smallmobile) {
      top: -5vh;
    }
  @include bp(most) {
    top: -10vh;
  }
}
.homesection.third img {
    top: -15vh;
}
/*
.homesection.fourth img {
  top: -10vh;
}
*/

.browse-section {
  background: $lightGrey;
/*   height: 250px; */
  white-space: nowrap;
  padding-bottom: 2em;
  padding-left: 1em;
  padding-top: 1px;
  h2 {
    text-align: center;
    font-size: 24px;
    font-weight: 200;
    margin: .75em 0 .375em;
    @include bp(most) {
      font-size: 36px;
    }
    a {
      color: $notblack;
      text-decoration: none;
    }
  }
  .featured-tags {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-y: hidden;
  }
  .featured-tag {
    display: inline-block;
    background: #FFF;
    font-size: 16px;
    margin-right: 1em;
    position: relative;
    line-height: 0;
    @include bp(mobile) {
      width: 80%;
    }
    img {
      width: 100%;
      @include bp(most) {
        width: 340px;
        height: 227px;
      }
    }
    .overlay {
      background: rgba(0, 0, 0, 0.75);
      color: #FFF;
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 1em;
      line-height: 1.4;
    }
    p {
      display: inline-block;
      margin: .75em 0 .5em;
      padding: 0 .125em;
      &.name {
        text-transform: uppercase;
      }
      &.plcount {
        float: right;
        color: #AFAFAF;
        font-weight: 300;
      }
    }
    &.see-all {
      background: $notblack;
      @include bp(most) {
        width: 340px;
        height: 227px;
      }
      a {
        display: block;
        text-align: center;
        color: #FFF;
        text-decoration: none;
        box-sizing: border-box;
        text-transform: uppercase;
        padding-top: 67.6%;
        line-height: 1.4;
        @incude bp(most) {
          padding-top: 0px;
        }
        span {
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0px;
          top: 0px;
          padding-top: 18%;
          box-sizing: border-box;
          @include bp(most) {
            padding-top: 20%;
          }
        }
      }
      i {
        display: block;
        color: $yellow;
        font-size: 4em;
        padding-bottom: .25em;
      }
    }
  }
}


.featured-locations {
  text-align: center;
  position: relative;
  padding: 1em;
  @include bp(most) {
    padding: 2em;
  }
  h1 {
    margin: 0;
    font-weight: 100;
    font-size: 24px;
    @include bp(most) {
      font-size: 36px;
    }
  }
  .featured-carousel {
    margin: 2em auto 0;
    position: relative;
    .slide {
      position: relative;
      max-width: 1028px;
      margin: 0px auto;
      .overlay {
        text-align: left;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 300;
        margin-top: -4px;
        background: $notblack;
        color: #FFF;
        padding: .75em;
        @include bp(most) {
          padding: 1em;
          margin-top: 0;
          position: absolute;
          bottom: 28px;
          left: 32px;
          width: 260px;
          height: 110px;
          background: rgba(255,255,255,.9);
          color: $notblack;
        }
        h3 {
          font-size: 24px;
          font-weight: 300;
          margin: 0px;

          @include bp(most) {
            border-bottom: 1px solid #979797;
            padding: .25em 0;
            margin-bottom: .25em;
          }
        }
      }
      img {
        width: 100%;
      }
    }
    .carousel-button {
      position: absolute;
      cursor: pointer;
      color: #595959;
      @include noselect();
      top: 50%;
      margin-top: -36px;
      i {
        font-size: 2em;
      }
      display: none;
      @include bp(most) {
        display: block;
      }
    }
    .next-button {
      display: none;
      right: 50%;
      margin-right: -584px;
      @include bp(large) {
        display: block;
      }
    }
    .previous-button {
      left: 50%;
      margin-left: -584px;
      display: none;
      @include bp(large) {
        display: block;
      }

    }
  }
}

.vue-typer {
    position: absolute;
    font-size: 14px;
    bottom: 15px;
    left: 20px;
    top: 95px;
    font-family: $noto;
    @include bp(most) {
      font-size: 18px;
      margin-left: -176px;
      top: 15px;
      left: 50%;
    }
}

.dropincontainer {
  width: 8em;
  height: 1em;
  display: inline-block;
  position: relative;
  b {
    width: 10em;
    visibility: hidden;
    position: absolute;
    left: 0px;
    top: 0px;
    text-align: left;
  }
  b.first {
    animation-name: dropFadeOut;
    animation-duration: 3s;
  }
  b.second {
    animation-name: dropFadeInOut;
    animation-duration: 2.25s;
    animation-delay: 2.5s;
  }
  b.third {
    animation-name: dropFadeInOut;
    animation-duration: 2.25s;
    animation-delay: 4.25s;
  }
  b.final {
    visibility: visible;
    animation-name: dropFadeInFinal;
    animation-duration: 6.75s;
  }
}

.bottom-yellow {
  background: $yellow;
  height: 8em;
}

span.clear {
  display: block;
  height: 1px;
  clear: both;
}

@keyframes dropFadeIn {
  0% {
    top: -3rem;
    opacity: 0;
  }
  25% {
    top: -3rem;
    opacity: 0;
  }
  100% {
    top: 0;
    opacity: 1;
  }

}

@keyframes dropFadeOut {
  0% {
    visibility: visible;
    top: 0rem;
    opacity: 1;
  }
  75% {
    visibility: visible;
    top: 0rem;
    opacity: 1;
  }
  100% {
    visibility: visible;
    top: 3rem;
    opacity: 0;
  }
}

@keyframes dropFadeInOut {
  0% {
    visibility: visible;
    top: -3rem;
    opacity: 0;
  }
  33% {
    visibility: visible;
    top: 0rem;
    opacity: 1;
  }
  66% {
    visibility: visible;
    top: 0rem;
    opacity: 1;
  }
  100% {
    visibility: visible;
    top: 3rem;
    opacity: 0;
  }
}
@keyframes dropFadeInFinal {
  0% {
    top: -3rem;
    opacity: 0;
  }
  88.89% {
    top: -3rem;
    opacity: 0;
  }
  100% {
    top: 0rem;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?0b41ff26